export enum GridType {
    NONE = 'no',
    IOSN = 'iosn',
    PORTFOLIO = 'portfolio',
}
